import { Injectable } from '@angular/core';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class ConvetToThousandsService {
  constructor(private confirmDialogService: ConfirmDialogService) {}

  confirmConvertToThousands(onConfirm: () => void): void {
    this.confirmDialogService.confirmThis_withClose(
      'Convert To 1,000s',
      `⚠️ Warning: This action will permanently convert all premium values in the grid to thousands of dollars.
    This change will affect all displayed data and cannot be undone.`,
      () => {
        onConfirm();
      },
      () => {
        // No action
      },
      () => {
        // Close action
        return;
      },
      true,               // confirmationTextRequired
      'I UNDERSTAND'      // requiredText
    );
  }
}